import * as yup from 'yup'
import { usernameSchema } from 'helpers/schemaHelpers'

const schema = yup.object().shape({
  username: usernameSchema,
  avatar: yup.number().notRequired(),
})
export default schema
